import React from 'react';
import type { BaseSkeletonProps } from '../types';

export interface SkeletonBarProps extends BaseSkeletonProps {
  /** Width of the skeleton bar (px, %, or valid CSS value) */
  width?: string | number;
  /** Height of the skeleton bar (px, %, or valid CSS value) */
  height?: string | number;
  /** Border radius */
  borderRadius?: string | number;
}

/**
 * SkeletonBar - Animated horizontal bar for loading states
 * 
 * Used for text content, values, and inline elements.
 * Supports pulse, shimmer, and wave animations.
 */
export const SkeletonBar: React.FC<SkeletonBarProps> = ({
  width = '100%',
  height = '16px',
  borderRadius = '4px',
  animation = 'pulse',
  className = '',
  style = {},
}) => {
  const normalizedWidth = typeof width === 'number' ? `${width}px` : width;
  const normalizedHeight = typeof height === 'number' ? `${height}px` : height;
  const normalizedRadius = typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius;

  return (
    <div
      className={`core-skeleton-bar core-skeleton-bar--${animation} ${className}`}
      style={{
        width: normalizedWidth,
        height: normalizedHeight,
        borderRadius: normalizedRadius,
        ...style,
      }}
      role="status"
      aria-label="Loading"
      aria-live="polite"
    />
  );
};

